document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-pc-article]').forEach((article) => {
    const content = article.querySelector('[data-pc-article-content]');
    const toc = article.querySelector('[data-pc-article-toc]');
    const list = article.querySelector('[data-pc-article-toc-list]');
    if (!content || !toc || !list) return;

    const normalizeHeading = (value) => value.trim().toLocaleLowerCase('de-DE');
    const embeddedTocHeading = [...content.querySelectorAll('h2')].find(
      (heading) => normalizeHeading(heading.textContent) === 'inhaltsverzeichnis',
    );

    if (embeddedTocHeading) {
      const dividerBefore = embeddedTocHeading.previousElementSibling;
      const embeddedList = embeddedTocHeading.nextElementSibling;
      const dividerAfter = embeddedList?.nextElementSibling;

      if (dividerBefore?.matches('hr')) dividerBefore.remove();
      if (embeddedList?.matches('ul, ol')) embeddedList.remove();
      if (dividerAfter?.matches('hr')) dividerAfter.remove();
      embeddedTocHeading.remove();
    }

    const headings = [...content.querySelectorAll('h2')];
    if (headings.length < 2) return;

    const summaryHeading = headings.find((heading) =>
      normalizeHeading(heading.textContent).includes('das wichtigste in kürze'),
    );
    const summaryList = summaryHeading?.nextElementSibling;
    if (summaryHeading && summaryList?.matches('ul, ol')) {
      summaryHeading.classList.add('pc-article__summary-title');
      summaryList.classList.add('pc-article__summary-list');
    }

    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `abschnitt-${index + 1}`;
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      item.appendChild(link);
      list.appendChild(item);
    });

    toc.hidden = false;
  });
});
